const ASC = "asc";
const DESC = "desc";

export const resolveListingSort = (obj = {}, sortBy, paginationObj = {}) => {
  if (obj.sort_field) {
    return {
      sort_field: obj.sort_field,
      sort_order: obj.sort_order || (obj.sort_field === "created_at" ? DESC : ASC),
    };
  }
  if (sortBy) {
    const sameAsPage = paginationObj.sort_field === sortBy && paginationObj.sort_order;
    return {
      sort_field: sortBy,
      sort_order:
        obj.sort_order ||
        (sameAsPage ? paginationObj.sort_order : sortBy === "created_at" ? DESC : ASC),
    };
  }
  if (paginationObj.sort_field) {
    return {
      sort_field: paginationObj.sort_field,
      sort_order: paginationObj.sort_order === DESC ? DESC : ASC,
    };
  }
  return { sort_field: "first_name", sort_order: ASC };
};
